import { useEffect, type ReactNode } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function RequireAuth({ children }: { children: ReactNode }) {
  const auth = useAuth();

  useEffect(() => {
    if (auth.status === "unauthenticated") {
      void auth.signIn(window.location.pathname + window.location.search);
    }
  }, [auth]);

  if (auth.status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-brand-600" />
      </div>
    );
  }

  if (auth.status === "forbidden") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
        <div className="max-w-md rounded-lg border border-red-200 bg-white p-6 text-center shadow-sm">
          <p className="text-sm font-medium text-slate-900">Acceso restringido</p>
          <p className="mt-2 text-sm text-slate-600">
            Esta consola es solo para administradores de plataforma. El número{" "}
            <span className="font-mono">{auth.user.phone}</span> no tiene rol admin.
          </p>
          <button
            type="button"
            className="mt-4 text-sm font-medium text-brand-600 hover:underline"
            onClick={() => auth.signOut()}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    );
  }

  if (auth.status !== "authenticated") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-brand-600" />
      </div>
    );
  }

  return <>{children}</>;
}